"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _jsxFileName = "src/icons/WarningTriangle.js";
var _react = require("react");
var _react2 = _interopRequireDefault(_react);
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
var WarningTriangle = function WarningTriangle(props) {
  return _react2.default.createElement("svg", Object.assign({
    className: "solid-icon",
    viewBox: "0 0 241.99 205.55"
  }, props, {
    __source: {
      fileName: _jsxFileName,
      lineNumber: 4
    },
    __self: undefined
  }), _react2.default.createElement("title", {
    __source: {
      fileName: _jsxFileName,
      lineNumber: 5
    },
    __self: undefined
  }, "Warning Triangle Icon"), _react2.default.createElement("path", {
    className: "solid-warning",
    d: "M239.86 183.24L133.69 7.17a14.83 14.83 0 0 0-25.39 0L2.13 183.24a14.7 14.7 0 0 0 12.7 22.31h212.33a14.7 14.7 0 0 0 12.7-22.31zM121 167.08a13.47 13.47 0 1 1 13.49-13.5 13.46 13.46 0 0 1-13.49 13.5zm13.3-85.36L127.63 121a6.75 6.75 0 0 1-13.3 0l-6.61-39.32a13.21 13.21 0 0 1-.19-2.27 13.47 13.47 0 0 1 26.95 0 13.23 13.23 0 0 1-.21 2.31z",
    __source: {
      fileName: _jsxFileName,
      lineNumber: 6
    },
    __self: undefined
  }));
};
exports.default = WarningTriangle;